import { api } from './client'

export const postTranscript = (sessionId, text, sourceLang, seq) =>
  api
    .post(`/subtitles/sessions/${sessionId}/transcript`, { text, sourceLang, seq })
    .then((r) => r.data)

export const stopTranslation = (sessionId) =>
  api.delete(`/subtitles/sessions/${sessionId}/stream`).then((r) => r.data)

// EventSource tidak bisa mengirim header Authorization. Yang dikirim lewat URL
// adalah tiket sekali-sesi berumur 60 detik, bukan access token (yang akan
// tercatat di log dan riwayat peramban).
export async function createSubtitleStream(sessionId) {
  const { data } = await api.post(`/subtitles/sessions/${sessionId}/ticket`)
  const base = (import.meta.env.VITE_API_URL || '') + '/api/v1'
  return new EventSource(`${base}/subtitles/sessions/${sessionId}/stream?ticket=${encodeURIComponent(data.ticket)}`)
}
